document.addEventListener('DOMContentLoaded', function() {
  const forgotPasswordBackButton = document.getElementById('back-button');
  const forgotPasswordNextButton = document.getElementById('next-button');
  const recoverEmail = document.getElementById('RecoverEmail');
  const forgotPasswordForm = document.getElementById('recover_customer_password');

  forgotPasswordBackButton.addEventListener('click', function() {
    window.location.href = '/account/login';
  });

  function enableNextButton() {
    const hasText = recoverEmail.value.trim().length > 0;
    forgotPasswordNextButton.disabled = !hasText;
  }
  
  recoverEmail.addEventListener('input', enableNextButton);
  forgotPasswordNextButton.addEventListener('click', function() {
    forgotPasswordForm.submit();
  });
});